import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
import loadScript from '@tv2/lib-core/loadScript';
import castPreset, { name } from '@tv2-player/cast-player/src/CastPreset';
import { makeMediaObject } from '../../services/media';
import { bootstrapAction, loadRequestFilter, mediaFilter, playerFilter } from '../extensions';
import cast from '../../types/chromecast-caf-receiver/index';
import { getAdobeVisitorMarketingCloudUserIdFromADBMobile } from '../../adobeUtils';
import { getPlayerConfiguration } from '../../config/player';
import store, { ENABLE_VCR } from '../../store';
import { deviceDetector } from '../../utils/deviceDetector';

export class UnifiedPlayerPlugin {
  player: UnifiedPlayer | null;
  adobeVisitorMarketingCloudUserId: string;
  media: ReturnType<typeof makeMediaObject>;

  init() {
    const playerConfiguration = getPlayerConfiguration();
    bootstrapAction.register(async context => {
      mediaFilter.register(async m => {
        this.media = m;
        return m;
      });
      context
        .getPlayerManager()
        .addEventListener(cast.framework.events.EventType.PLAYER_LOADING, () => {
          this.player?.update({ media: this.media });
        });
      context.addEventListener(cast.framework.system.EventType.SHUTDOWN, () => {
        this.shutdownUnifiedPlayer();
      });

      context.getPlayerManager().addEventListener(cast.framework.events.EventType.ERROR, e => {
        if (e.detailedErrorCode === cast.framework.events.DetailedErrorCode.LOAD_FAILED) {
          this.shutdownUnifiedPlayer();
        }
      });

      const adobeConfig = playerConfiguration.adobe;
      Object.assign(adobeConfig.mediaHeartbeat, {
        appVersion: UnifiedPlayer.version,
        playerName: name,
        ...adobeConfig.mediaHeartbeat,
      });
      window.ADBMobileConfig = adobeConfig;
      await loadScript('/vendor/adobe/3.0.3/adbmobile-chromecast.min.js');
      this.adobeVisitorMarketingCloudUserId =
        await getAdobeVisitorMarketingCloudUserIdFromADBMobile();
    });
    loadRequestFilter.register(async loadRequestData => {
      // Do not shutdown the player if the load request is a preload request
      if (loadRequestData.type === cast.framework.messages.MessageType.PRELOAD) {
        return loadRequestData;
      }

      this.shutdownUnifiedPlayer();
      this.player = await playerFilter.apply(
        castPreset(
          {
            ...playerConfiguration,
            enableVcr: store.get(ENABLE_VCR) ?? false,
            adobe: {
              ...playerConfiguration.adobe,
              visitorMarketingCloudUserId: this.adobeVisitorMarketingCloudUserId,
            },
          },
          cast,
          deviceDetector() as any
        )
      );
      return loadRequestData;
    });
  }

  shutdownUnifiedPlayer() {
    this.player?.destroy();
    this.player = null;
  }
}
